export default "__VITE_ASSET__OPkhFa9d__"